module.exports = __webpack_public_path__ + "img/Georgia_Center_-_RQ-_t-19411-s001.fa0394bb.jpg";